<template>
  <!-- 诊疗金管理 -->
  <div class="bg-white px-3 index">
    <div class="add_tits" ref="title">
      <el-form :inline="true" :model="formInline" class="form-inlines u-f u-jsb">
        <div>
          <el-form-item label="姓名">
            <el-input v-model="formInline.user" placeholder="查询" size="mini" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="begin" size="mini">查询</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="primary" @click="zsyhq" size="mini">选择用户</el-button>
            <el-button type="info" @click="zsyhqall(1)" size="mini">全部显示</el-button>
            <el-button type="" @click="zsyhqall(2)" size="mini">全部隐藏</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%" :height="heights" v-loading="loading">
      <el-table-column prop="user_id" label="ID"> </el-table-column>
      <el-table-column prop="username" label="昵称"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="fund_code" label="诊疗金" width="250px">
      </el-table-column>
      <el-table-column prop="phone" label="手机号" width="120px"> </el-table-column>
      <el-table-column prop="used" label="领取状态">
        <template slot-scope="{ row }">
          <span>{{row.fund_code?'已领取':'未领取'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="used" label="状态">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" v-if="row.used == 1">已使用</el-button>
          <el-button type="text" size="mini" v-else>未使用</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="时间" show-overflow-tooltip=""> </el-table-column>
      <el-table-column prop="operation" label="操作" fixed="right">
        <template slot-scope="{ row }">
          <div v-if="row.fund_code">
            <el-button @click="handleClick(row)" type="success" size="mini" v-if="row.used == 0">使用</el-button>
            <el-button type="info" size="mini" v-else>已使用</el-button>
          </div>
          <div v-else>未领取</div>

        </template>
      </el-table-column>
    </el-table>
    <div class="u-f u-ac u-jsb ft_mr">
      <div></div>
      <div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[15, 30, 50, 100]" :page-size="pagesize" layout="total, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="选择用户" width="80%" :visible.sync="zsdialoged" @close='closedialo' top="20px" center
      class="dialogs">
      <el-divider></el-divider>
      <div class="dialog-ibox-content">
        <el-form ref="forms" label-width="140px" class="demo-ruleForm" inline>
          <el-form-item label="选择用户">
            <el-form-item>
              <el-input v-model="userkeyword" placeholder="请输入昵称、手机号" style="width:200px" clearable size="small">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="beginsearchusers">搜索
              </el-button>
            </el-form-item>
            <el-form-item label="赠送数量">
              <el-input v-model="zs_count" placeholder="请输入赠送数量" style="width:200px" min="1" size="small" type="number">
              </el-input>
            </el-form-item>
          </el-form-item>
        </el-form>
        <div class="u-f">
          <div style="width:50%">
            <el-table :data="userTableData" border v-loading="loading" height="430" ref="configurationTables"
              @selection-change="handleSelectionChange" :row-key="getRowKeys">
              <el-table-column type="selection" width="55" :reserve-selection="true" />
              <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                <template slot-scope="scope">
                  <img :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                    alt="" width="50" class="tablimg">
                </template>
              </el-table-column>
              <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
              <div></div>
              <div>
                <el-pagination @size-change="userhandleSizeChange" @current-change="userhandleCurrentChange"
                  :current-page="usercurrentPage" :page-sizes="[10, 20, 30, 40]" :page-size="userpagesize"
                  layout="total, sizes, prev, pager, next" :total="usercount">
                </el-pagination>
              </div>
            </div>
          </div>
          <div style="width:50%;margin-left:10px">
            <el-table :data="sendusers" border v-loading="loading" height="430" ref="configurationTable">
              <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                <template slot-scope="scope">
                  <img :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                    alt="" width="50" class="tablimg">
                </template>
              </el-table-column>
              <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submited()" :loading='sendloading' size="small">确 定</el-button>
        <el-button @click="zsdialoged = false" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        //表格
        tableData: [],
        //搜索条件
        formInline: {
          user: "",
        },
        count: 0,
        currentPage: 1,
        pagesize: 15,
        heights: null,
        loading: false,
        zsdialoged: false,
        userTableData: [],
        loading: false,
        usercurrentPage: 1,
        userpagesize: 10,
        usercount: 0,
        sendusers: [],
        userkeyword: '',
        lb_value: '',
        zs_count: 1,
        sendloading: false,
      };
    },
    created() {
      this.onSubmit();
    },
    mounted() {
      this.getHeight()
    },
    methods: {
      // 获取高度
      getHeight() {
        let that = this;
        that.heights = window.innerHeight - 270 + 'px'
        window.onresize = () => {
          that.heights = window.innerHeight - 270 + 'px'
        }
      },
      // 使用按钮
      handleClick(row) {
        this.$confirm("确定将此诊疗金码设置为已使用状态吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            axios
              .post(
                "/admin/examine", {
                  used: 1,
                  id: row.id,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == 200) {
                  this.$message({
                    type: "success",
                    message: "使用成功!",
                  });
                  this.onSubmit()
                } else {
                  this.$message(res.data.msg)
                }
              })
              .catch((error) => {});
          })
          .catch(() => {});
      },
      begin() {
        this.currentPage = 1
        this.onSubmit()
      },
      onSubmit() {
        this.loading = true
        axios
          .post(
            "/admin/fundList", {
              page: this.currentPage,
              keyword: this.formInline.user
            }, {
              token: true,
            }
          )
          .then((response) => {
            this.loading = false
            this.tableData = response.data.data.list;
            this.count = response.data.data.totalCount;
          })
          .catch((error) => {});
      },
      handleSizeChange(val) {
        let that = this;
        that.pagesize = val;
        that.onSubmit();
      },
      handleCurrentChange(val) {
        let that = this;
        that.currentPage = val;
        that.onSubmit();
      },
      closedialo() {
        this.userkeyword = ''
        this.sendusers = []
        this.$nextTick(() => {
          this.$refs.configurationTables.clearSelection();
        })
      },
      beginsearchusers() {
        this.usercurrentPage = 1
        this.searchusers()
      },
      searchusers() {
        let that = this
        that.loading = true
        axios
          .post("/admin/User/userList", {
            page: that.usercurrentPage,
            page_count: that.userpagesize,
            keyword: this.userkeyword,
            customer_type: this.lb_value

          }, {
            token: true
          })
          .then(response => {
            that.loading = false
            that.userTableData = response.data.data.list
            that.usercount = response.data.data.totalCount

          })
          .catch(error => {})
      },
      zsyhq() {
        this.zsdialoged = true
        this.beginsearchusers()
      },
      zsyhqall(t) {
        this.$confirm(`确定将诊疗金设置为所有用户${t==1?'显示':'隐藏'}吗?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            axios
              .post(
                "/admin/sendAllUserFund", {
                  type: t,
                }, {
                  token: true,
                }
              )
              .then((response) => {
                if (response.data.code == 200) {
                  this.$message({
                    type: "success",
                    message: "成功!",
                  });
                  this.onSubmit()
                } else {
                  this.$message(res.data.msg)
                }
              })
              .catch((error) => {});
          })
          .catch(() => {});
      },

      handleSelectionChange(val) {
        this.sendusers = val;
      },
      getRowKeys(row) {
        return row.id; // id为列表数据的唯一标识
      },
      userhandleSizeChange(val) {
        let that = this
        that.userpagesize = val;
        that.searchusers()
      },
      userhandleCurrentChange(val) {
        let that = this
        that.usercurrentPage = val;
        that.searchusers()
      },
      async submited() {
        let userids = this.sendusers.map(ele => ele.id);
        if (userids.length == 0) return this.$message.error('请选择用户')
        this.sendloading = true
        let res = await this.ajax('admin/sendFund', {
          user_ids: userids,
        })
        if (res.code == 200) {
          this.$message.success('赠送成功')
          this.zsdialoged = false
          this.begin()
        } else {
          this.$message(res.msg)
        }
        this.sendloading = false

      },
    },
  };
</script>

<style>
</style>